module.exports = __webpack_public_path__ + "images/lazyload_placeholder_dd5e7ed1e9e84a589eb1e8e6eaf597b7.jpg";